import { useState, useEffect } from "react";

import DOMPurify from "dompurify";
import axios from "axios";

function SubscribeBlog() {
  const [status, setStatus] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {}, []);

  const handleEmail = (e) => {
    setEmail(DOMPurify.sanitize(e.target.value));
    setStatus("");
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (email == "") {
        setStatus("");
      }

      setEmail("");

      const response = await axios.post("/api/newsletter", {
        email,
      });

      if (response.data.status === 200) setStatus("Inscription Réussite !");
      else setStatus("Réessayez plus tard !");
    } catch (e) {
      setStatus("Réessayez plus tard !");
    }
  };

  return (
    <div className="w-full px-8   my-4 hidden md:flex items-center justify-center max-w-7xl">
      <div className=" w-full flex flex-col lg:flex-row items-center justify-center text-backbg/80 bg-[#f6f5f7] py-6 lg:max-w-7xl max-w-md px-12 gap-4 lg:gap-0 lg:px-8 ">
        <div className="text-center lg:text-start  w-full lg:w-1/2 flex flex-col items-center lg:items-start justify-center gap-4 lg:gap-0  ">
          <p className="font-bold text-[4.1vw] xs:text-[3vw] sm:text-[2.2vw] md:text-[2vw] lg:text-[1.5vw] xl:text-[1.vw]  bl:text-[0.85vw] ">Abonnez-vous à notre newsletter !</p>
          <p className=" text-[3.5vw] xs:text-[2.4vw] sm:text-[1.8vw] md:text-[1.6vw] lg:text-[1.1vw] xl:text-[0.85vw] bl:text-[0.7vw]  ">
            Inscrivez-vous à notre newsletter par email pour recevoir des articles utiles.
          </p>
        </div>
        <form id="formSubscribe" method="post" onSubmit={handleSubmit} className="flex flex-col lg:flex-row items-center justify-center    gap-4 g-red-800  w-full lg:w-1/2">
          <div className="border-b-[1px] w-full lg:w-2/3  ">
            <input
              required
              maxLength="40"
              type="email"
              name="email"
              placeholder="Entrer votre Email"
              className=" text-hp8 w-full input-newsletter  py-2  "
              onChange={(e) => handleEmail(e)}
              value={email}
            />
          </div>
          <div className="flex flex-col w-fit  items-center justify-center lg:w-1/3">
            <button
              disabled={email == "" ? true : false}
              type="submit"
              value="SUBMIT"
              className={` md:hover:cursor-pointer  md:hover:bg-mainDark/90  bg-btnDark  p-2 px-4 w-full  text-hp10 text-white `}
            >
              {status === "" ? "Inscrivez-vous" : status}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SubscribeBlog;
